import React, { useState } from "react";
import { APP_DOMAIN} from "../../constants/constants";
export  const CommingSoonSection = () =>{
    return(
        <>
         <div className="comming-soon-section">
                    <div className="deshboard-head">
                        <h1>Coming Soon: Next-Level AI Tools!</h1>
                        <p className="no-resume-pera">We’re building powerful AI features to help you land your next job even faster. Here’s what’s on the way:</p>
                        </div>
                    <div className="list-container">
                        <div className="list-item">
                            <div className="icon">
                                <img
                                    src={`${APP_DOMAIN}/assets/images-new/icons/AI_Resume_Chatbot.png`}
                                    alt="AI resume assistant"
                                />
                            </div>
                            <div className="info">
                                <h3>AI Resume Chatbot (Coming Soon!)</h3>
                                <p>Ask questions and get real-time resume help</p>
                            </div>
                        </div>
                        <div className="list-item">
                            <div className="icon">
                                <img
                                    src={`${APP_DOMAIN}/assets/images-new/icons/AI-Optimized_Resumes.png`}
                                    alt="Browse professional resume templates"
                                />
                            </div>
                            <div className="info">
                                <h3>AI-Optimized Resumes</h3>
                                <p>Tailor your resume to match job descriptions instantly.</p>
                            </div>
                        </div>
                        <div className="list-item">
                            <div className="icon">
                                <img
                                    src={`${APP_DOMAIN}/assets/images-new/icons/AI_Job_Interview_Assistant.png`}
                                    alt="Customize your resume design"
                                />
                            </div>
                            <div className="info">
                                <h3>AI Job Interview Assistant</h3>
                                <p>Practice with AI-generated interview questions and get personalized feedback.</p>
                            </div>
                        </div>
                        <div className="list-item">
                            <div className="icon">
                                <img
                                    src={`${APP_DOMAIN}/assets/images-new/icons/Advanced_AI_Editing.png`}
                                    alt="Find inspiration from sample resumes"
                                />
                            </div>
                            <div className="info">
                                <h3>Advanced AI Editing</h3>
                                <p>Rewrite sections, adjust tone, and add bullet points with AI-powered refinements.</p>
                            </div>
                        </div>
                    </div>
         </div>
        </>
    )
}